
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cap-de-setmana-a-cardedeu",
      function () {
        return require("private-next-pages/cap-de-setmana-a-cardedeu.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cap-de-setmana-a-cardedeu"])
      });
    }
  